import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();

  return {
    tooltipWrapper: css`
      position: relative;
      display: inline-block;
    `,

    // Backdrop only appears on mobile when visible
    mobileBackdrop: visible => css`
      display: none;
      @media (max-width: ${breakpoints.sm || '767px'}) {
        display: ${visible ? 'block' : 'none'};
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.15);
        z-index: 1;
      }
    `,

    iconStyle: visible => css`
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: transparent;
      /* add styles for tab focus */
      &:focus-visible {
        background : ${colors.skip_yellow};
        border: 2px solid ${colors.border_black};
        color: ${colors.border_black};
      }
      /* Apply hover only on hover-capable devices */
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background: #e9ebf1;
          color: ${colors.navy};
        }
      }
      &:active {
        background: ${colors.navy};
        color: ${colors.white};
      }
      ${visible &&
      css`
        background: ${colors.navy};
        color: ${colors.white};
      `}
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 44px;
        height: 44px;
      }
    `,

    tooltipBox: visible => css`
      position: absolute;
      top: 0;
      left: calc(100% + 24px);
      width: 280px;
      border: 1px solid #e5e7eb;
      display: flex;
      font-size: 14px;
      color: #374151;
      z-index: 99;
      display: ${visible ? 'flex' : 'none'};
      transform: ${visible ? 'translateY(0)' : 'translateY(6px)'};
      overflow-wrap: anywhere;
      padding: 24px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 12px;
      border-radius: 8px;
      background: ${colors.white};
      /* FF card hover */
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
      /* ===== Mobile: turn into centered modal card ===== */
      @media (max-width: ${breakpoints.sm || '767px'}) {
        position: fixed;
        top: 94px;
        left: 24px;
        right: 24px;
        width: auto;
      }
    `,
    head: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      align-self: stretch;
    `,
    headTitle: css`
      color: ${colors.ocean_depth_navy};
      font-family: 'FS Dillon';
      font-size: 21.6px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.11px;
    `,
    closeBtn: css`
      position: relative;
      display: flex;
      width: 2rem;
      height: 2rem;
      padding: 5px;
      justify-content: center;
      align-items: center;
      color: ${colors.red};
      background: none;
      border: none;
      font-size: 1rem;
      cursor: pointer;
      /* add styles for tab focus */
      &:focus-visible {
        background: ${colors.skip_yellow};
        color: ${colors.border_black};
        border: 2px solid ${colors.border_black};
        border-radius: 100%;
      }
      &:hover {
        color: ${colors.blue};
      }
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 44px;
        height: 44px;
      }
    `,
    body: css`
      & div {
        margin-bottom: 1.5rem;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      color: ${colors.divider_gray};
      font-family: 'FS Dillon';
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.25rem;
      letter-spacing: 0.24px;
      strong {
        display: block;
        margin-bottom: 0.25rem;
        color: ${colors.divider_gray};
        font-family: 'FS Dillon';
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0.049px;
      }

      a {
        color: #1D4ED;
        text-decoration: underline;
        &:hover {
          text-decoration-thickness: 2px;
          font-weight: 700;
        }
        /* add styles for tab focus */
        &:focus-visible {
          background: ${colors.skip_yellow};
          color: ${colors.border_black};
          outline: none;
        }
        color: ${colors.divider_gray};
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
      }
    `,
  };
};
